<template>
  <div
    class="sound-controller"
    data-apollo-hover
    data-apollo-hover-animation="scale-center"
    @click="toggle"
    @mouseout="removeClass"
  >
    <div class="sound-controller__label">
      <span>{{ $t('sound') }}&nbsp;.&nbsp;</span>
    </div>
    <div
      class="sound-controller__state"
      :class="{ 'on': $store.state.sound, 'off': !$store.state.sound }"
    >
      <div class="state state--on">On</div>
      <div class="state state--off">Off</div>
    </div>
  </div>
</template>

<script>
import { TweenMax, Linear } from 'gsap';
import { mapGetters } from 'vuex';

export default {
  name: 'SoundController',

  data() {
    return {
      audio: null,
    };
  },

  computed: {
    ...mapGetters(['sound']),
  },

  watch: {
    sound(newVal) {
      if (newVal) {
        TweenMax.to(this.audio, 1, { volume: 0.1, ease: Linear.easeNone });
        this.audio.play();
      } else {
        TweenMax.to(this.audio, 1, {
          volume: 0,
          ease: Linear.easeNone,
          onComplete: () => {
            this.audio.pause();
          },
        });
      }
    },
  },

  mounted() {
    this.audio = new Audio('/static/audio/background.mp3');
    this.audio.loop = true;
    this.audio.volume = 0;
    this.audio.pause();
  },

  methods: {
    toggle() {
      this.$store.commit('TOGGLE_SOUND');
      this.$el.classList.add('clicked');
    },
    removeClass() {
      this.$el.classList.remove('clicked');
    },
  },
};
</script>

<style lang="scss" scoped>
.sound-controller {
  font-weight: normal;
  font-size: rem(22px);
  display: flex;
  align-items: flex-end;
  font-size: $font-size-text;
  transition: color .6s $inOutCubic;
  cursor: pointer;

  @include mq($until: ipadP) {
    display: none;
  }

  @include mq($and: $is-touch-device) {
    display: none;
  }

  @at-root .menu-open & {
    color: $color-black;
  }

  @at-root .page-white & {
    color: $color-black;
  }

  &__label {
    @at-root .menu-open & {
      color: $color-gray;
    }

    @at-root .page-white & {
      color: $color-black;
    }
  }

  &:not(.clicked):hover {
    .sound-controller__state {
      .state--on {
        opacity: 0.5;
        transform: translateY(50%);
      }

      .state--off {
        opacity: 0.5;
        transform: translateY(50%);
      }
    }
  }

  &__state {
    .state--on,
    .state--off {
      transition: transform .6s $inOutCubic,
                  opacity .6s $inOutCubic;
    }

    &.off {
      .state--on {
        opacity: 0;
        transform: translateY(0%);
      }

      .state--off {
        opacity: 1;
        transform: translateY(0%);
      }
    }

    &.on {
      .state--on {
        opacity: 1;
        transform: translateY(100%);
      }

      .state--off {
        opacity: 0;
        transform: translateY(100%)
      }
    }
  }
}
</style>
